/** @param {unknown} err */
export function parseApiError(err) {
  const status = err?.response?.status;
  const data = err?.response?.data;
  const detail = data?.detail;
  let code = 'unknown';
  let message = '';
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    code = detail.code || code;
    message = detail.message || '';
  } else if (typeof detail === 'string') {
    message = detail;
  }
  if (!message && data?.message) message = data.message;
  return { status, code, message };
}
